import script from "./BalImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalImage.vue?vue&type=script&lang=ts&setup=true"

import "./BalImage.vue?vue&type=style&index=0&id=85b10de4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85b10de4"]])

export default __exports__